<template>
    <div class="page_hx_core flex-col">
        <div class="group_10 flex-row">
            <div class="section_9 flex-col">
                <span class="text_27">协助应对企业面临的普遍问题</span>
                <span class="text_28">SOLVE&nbsp;THE&nbsp;CORE&nbsp;PAIN&nbsp;POINTS</span>
                <div class="list_10">
                    <div class="list-items_1 flex-col" v-for="(item, index) in loopData1" :key="item.id" @click="toggleItem(item.id)">
                        <img
                                v-if="item.slot1 === 1 && !activeItems[item.id]"
                                class="image_10"
                                referrerpolicy="no-referrer"
                                :src="item.specialSlot1.lanhuimage0"
                        />
                        <img
                                v-if="item.slot2 === 2 && !activeItems[item.id]"
                                class="label_5"
                                referrerpolicy="no-referrer"
                                src="../../../assets/advisory/advisory_solve_icon_01.png"
                        />
                        <span class="text_29" v-html="item.lanhutext0" v-show="!activeItems[item.id]"></span>

                        <div class="hover-mask" v-show="activeItems[item.id]">
                            <div class="hover-content">
                                <div class="problem-section">
                                    <div class="box_16 flex-col">
                                        <div class="icon-wrapper flex-row justify-between">
                                            <img
                                                    class="thumbnail_2"
                                                    referrerpolicy="no-referrer"
                                                    src="../../../assets/advisory/advisory_problem_icon.png"
                                            />
                                            <span class="text-group_8">{{ item.problem.title }}</span>
                                        </div>
                                        <span class="text_38">{{ item.problem.value }}</span>
                                    </div>
                                </div>
                                <div class="solution-section">
                                    <div class="box_16 flex-col">
                                        <div class="icon-wrapper  flex-row justify-between">
                                            <img
                                                    class="thumbnail_2"
                                                    referrerpolicy="no-referrer"
                                                    src="../../../assets/advisory/advisory_solve_icon.png"
                                            />
                                            <span class="text-group_8">{{ item.solve.title }}</span>
                                        </div>
                                        <span class="text_38">{{ item.solve.value }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="list_10">
                    <div class="list-items_1 flex-col" v-for="(item, index) in loopData2" :key="item.id" @click="toggleItem(item.id)">
                        <img
                                v-if="item.slot1 === 1 && !activeItems[item.id]"
                                class="image_10"
                                referrerpolicy="no-referrer"
                                :src="item.specialSlot1.lanhuimage0"
                        />
                        <img
                                v-if="item.slot2 === 2 && !activeItems[item.id]"
                                class="label_5"
                                referrerpolicy="no-referrer"
                                src="../../../assets/advisory/advisory_solve_icon_01.png"
                        />
                        <span class="text_29" v-html="item.lanhutext0" v-show="!activeItems[item.id]"></span>

                        <div class="hover-mask" v-show="activeItems[item.id]">
                            <div class="hover-content">
                                <div class="problem-section">
                                    <div class="box_16 flex-col">
                                        <div class="icon-wrapper flex-row justify-between">
                                            <img
                                                    class="thumbnail_2"
                                                    referrerpolicy="no-referrer"
                                                    src="../../../assets/advisory/advisory_problem_icon.png"
                                            />
                                            <span class="text-group_8">{{ item.problem.title }}</span>
                                        </div>
                                        <span class="text_38">{{ item.problem.value }}</span>
                                    </div>
                                </div>
                                <div class="solution-section">
                                    <div class="box_16 flex-col">
                                        <div class="icon-wrapper  flex-row justify-between">
                                            <img
                                                    class="thumbnail_2"
                                                    referrerpolicy="no-referrer"
                                                    src="../../../assets/advisory/advisory_solve_icon.png"
                                            />
                                            <span class="text-group_8">{{ item.solve.title }}</span>
                                        </div>
                                        <span class="text_38">{{ item.solve.value }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                activeItems: {}, // 用于跟踪每个项目的状态
                loopData1: [
                    {
                        id:101,
                        lanhutext0: '真实性存疑',
                        specialSlot1: {
                            lanhuimage0: require('../../../assets/advisory/advisory_solve2_icon_01.png'),
                        },
                        problem: {title:'痛点',value:'活动与相关费用真实性核查困难'},
                        solve:{title:'解决方案',value:'系统智能识别+人工深度核查，有效核验活动真实性，降低潜在风险、节省无效支出'},
                        slot1: 1
                    },
                    {
                        id:102,
                        lanhutext0: '合规风险频发',
                        specialSlot1: {
                            lanhuimage0: require('../../../assets/advisory/advisory_solve2_icon_02.png'),
                        },
                        problem: {title:'痛点',value:'行业监管加码，违规事件频现'},
                        solve:{title:'解决方案',value:'依托行业经验与团队洞察，精准甄别活动及费用与商业逻辑、制度法规的契合度，确保合规运营'},
                        slot1: 1
                    },
                ],
                loopData2: [
                    {
                        id:103,
                        lanhutext0: '政策响应滞后',
                        specialSlot1: {
                            lanhuimage0:require('../../../assets/advisory/advisory_solve_icon04.png'),
                        },
                        slot1: 1 ,
                        problem: {title:'痛点',value:'监管新规解读与执行脱节'},
                        solve:{title:'解决方案',value:'建立新规预警机制，及时提供合规培训与针对性整改解决方案，有效缩短政策落地周期'},
                    },
                    {
                        id:104,
                        lanhutext0: '内控体系薄弱',
                        specialSlot1: {
                            lanhuimage0:require('../../../assets/advisory/advisory_solve2_icon_04.png'),
                        },
                        problem: {title:'痛点',value:'缺乏独立的第三方监督'},
                        solve:{title:'解决方案',value:'建立独立第三方的突击核查+长效监测机制，完善内部 "预防-识别-应对"闭环管理体系'},
                        slot1: 1
                    }
                ],
            };
        },
        methods: {
            toggleItem(id) {
                // 切换项目的显示状态
                this.$set(this.activeItems, id, !this.activeItems[id]);
            }
        }
    };
</script>

<style scoped lang="css">
    .page_hx_core {
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        width: 100%;
        overflow: hidden;
    }

    .group_10 {
        width: 100%;
    }
    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .section_9 {
        background-color: rgba(255, 255, 255, 1);
        width: calc(100% - 20px);
        align-items: center;
        padding-left: 10px;
        padding-right: 10px;
    }

    .text_27 {
        width: 100%;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 24px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 53px;
        margin: 48px 0 0 0;
    }

    .text_28 {
        width: 100%;
        height: 37px;
        overflow-wrap: break-word;
        color: rgba(135, 135, 135, 1);
        font-size: 15px;
        text-align: center;
        white-space: nowrap;
        line-height: 37px;
        margin-bottom: 10px;
    }

    .list_10 {
        width: 100%;
        max-width: 1200px;
        margin: 10px auto 10px;
        display: flex;
        justify-content: center;
        gap: 10px;
    }

    .list-items_1 {
        border-radius: 10px;
        position: relative;
        width: 50%;
        max-width: 280px;
        height: 225px;
        border: 1px solid rgba(230, 230, 230, 1);
        align-items: center;
        overflow: hidden;
        cursor: pointer; /* 添加指针样式表示可点击 */
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .hover-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(229, 242, 242, 1);
        border-radius: 10px;
        padding: 20px;
        box-sizing: border-box;
    }

    .hover-content {
        color: white;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .problem-section,
    .solution-section {
        display: flex;
        align-items: flex-start;
        gap: 5px;
    }

    .icon-wrapper {
        width: 59px;
        height: 22px;
        margin: 5px 0 0 10px;
    }
    .thumbnail_2 {
        width: 18px;
        height: 18px;
        margin-top: 2px;
        margin-right: 8px;
    }
    .text-group_8 {
        width: 32px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(0, 106, 112, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 22px;
    }
    .text_38 {
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 18px;
        text-align: left;
        line-height: 25px;
        margin: 2px 0 0 35px;
    }

    .image_10 {
        position: absolute;
        top: 65px;
        width: 50px;
        height: 50px;
    }

    .label_5 {
        position: absolute;
        top: 68px;
        width: 31px;
        height: 44px;
    }

    .text_29 {
        width: 180px;
        height: 30px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 22px;
        text-align: center;
        white-space: nowrap;
        line-height: 30px;
        margin: 139px 0 0 0;
    }

    /* 超小屏幕样式 */
    @media (max-width: 480px) {
        .hover-mask {
            padding: 6px;
        }
        .text_38 {
            font-size: 10px;
            text-align: left;
            line-height: 15px;
            margin: 2px 0 0 35px;
        }
        .solution-section {
            margin-top: -5px;
        }
        .list-items_1 {
            height: 140px;
        }
        .image_10 {
            top: 35px;
            width: 40px;
            height: 40px;
        }
        .label_5 {
            top: 35px;
            width: 30px;
            height: 40px;
        }
        .text_29 {
            font-size: 20px;
            margin: 90px 0 0 0;
        }
        .text-group_8 {
            font-size: 15px;
        }
    }
    @media (max-width: 390px) {
        /**特别设定**/
        .box_16 {
            margin-top: -4px;
        }
        .hover-mask {
            padding: 4px;
        }
        .text_38 {
            font-size: 10px;
            text-align: left;
            line-height: 15px;
            margin: 2px 0 0 35px;
        }
        .solution-section {
            margin-top: -5px;
        }
        .list-items_1 {
            height: 140px;
        }
        .image_10 {
            top: 35px;
            width: 40px;
            height: 40px;
        }
        .label_5 {
            top: 35px;
            width: 30px;
            height: 40px;
        }
        .text_29 {
            font-size: 20px;
            margin: 90px 0 0 0;
        }
        .text-group_8 {
            font-size: 14px;
        }
    }

</style>
